import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedCommonModule } from "app/back-office/shared/common.module";
import { splitByUppercaseModule } from "app/shared/pipe/split-by-uppercase/split-by-uppercase.module";
import { BadgeColorStatusPipe } from "./badge-color-status.pipe";
import { DecimalNumberPipe } from "./decimal-number.pipe";
import { MyDatePipe } from "./my-date.pipe";

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    SharedCommonModule,
    splitByUppercaseModule
  ],
  declarations: [
    DecimalNumberPipe,
    MyDatePipe,
    BadgeColorStatusPipe,
  ],
  exports: [
    splitByUppercaseModule,
    DecimalNumberPipe,
    MyDatePipe,
    BadgeColorStatusPipe,
  ]
})
export class PipesModule { }
